import React from 'react'
import { Breadcrumb as BaseBreadcrumb } from '../components/Breadcrumb/Breadcrumb'
import BreadcrumbItem from 'reactstrap/lib/BreadcrumbItem'
import { Route, Switch, useHistory } from 'react-router-dom'
import ROUTES from '../../routes'
import PictoFontAwesome from '../components/Pictos/PictoFontAwesome'
import Button from '../components/Buttons/Button'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useTranslator } from '../../hooks'

const BackButton = ({ label, link }) => {
  const history = useHistory()
  const goTo = () => history.push(link)
  return (
    <Button color="link" onClick={goTo}>
      <PictoFontAwesome icon={faChevronLeft} />
      <span>{label}</span>
    </Button>
  )
}

const Breadcrumb = () => {
  const translator = useTranslator()
  return (
    <BaseBreadcrumb>
      <BreadcrumbItem>
        <Switch>
          <Route exact path={ROUTES.order}>
            <BackButton link={ROUTES.home} label={translator('breadcrumb.back.order')} />
          </Route>
          <Route exact path={ROUTES.refund}>
            <BackButton link={ROUTES.home} label={translator('breadcrumb.back.refund')} />
          </Route>
          <Route exact path={ROUTES.voucher}>
            <BackButton link={ROUTES.home} label={translator('breadcrumb.back')} />
          </Route>
        </Switch>
      </BreadcrumbItem>
    </BaseBreadcrumb>
  )
}

export default Breadcrumb
